// Friendly names mapping for connectors
export const getConnectorFriendlyName = (connectorType: string): string => {
  const friendlyNames: Record<string, string> = {
    'amazon_selling_partner': 'Amazon Selling Partner',
    'shopify': 'Shopify',
    'xero': 'Xero',
    'quickbooks': 'QuickBooks',
    'stripe': 'Stripe',
    'paypal': 'PayPal',
    'square': 'Square',
    'salesforce': 'Salesforce',
    'hubspot': 'HubSpot',
    'mailchimp': 'Mailchimp',
    'google_analytics': 'Google Analytics',
    'facebook_ads': 'Facebook Ads',
    'google_ads': 'Google Ads',
    'linkedin_ads': 'LinkedIn Ads',
    'pinterest_ads': 'Pinterest Ads',
    'tiktok_ads': 'TikTok Ads',
    'snapchat_ads': 'Snapchat Ads',
    'twitter_ads': 'Twitter Ads',
    'bing_ads': 'Microsoft Advertising',
    'amazon_ads': 'Amazon Ads',
    'etsy': 'Etsy',
    'ebay': 'eBay',
    'walmart': 'Walmart',
    'walmart_marketplace': 'Walmart Marketplace',
    'target': 'Target',
    'wayfair': 'Wayfair',
    'overstock': 'Overstock',
    'newegg': 'Newegg',
    'rakuten': 'Rakuten',
    'jet': 'Jet.com',
    'wish': 'Wish',
    'mercado_libre': 'MercadoLibre',
    'allegro': 'Allegro',
    'cdiscount': 'Cdiscount',
    'fruugo': 'Fruugo',
    'bonanza': 'Bonanza',
    'reverb': 'Reverb',
    'poshmark': 'Poshmark',
    'tradesy': 'Tradesy',
    'vestiaire_collective': 'Vestiaire Collective',
    'the_realreal': 'The RealReal',
    'stockx': 'StockX',
    'goat': 'GOAT',
    'grailed': 'Grailed',
    'depop': 'Depop',
    'vinted': 'Vinted',
    'threadup': 'ThredUP',
    'fashionphile': 'Fashionphile',
    'rebag': 'Rebag',
    'plaid': 'Plaid Banking',
    'csv': 'CSV Import'
  };

  return friendlyNames[connectorType] || connectorType.split('_').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  ).join(' ');
};